import e from "case";
const i = {
  AddFraction: () => import("./Components/Gameplays/AddFraction/AddFraction.js"),
  AlterSum: () => import("./Components/Gameplays/AlterSum/AlterSum.js"),
  ArcOnRuler: () => import("./Components/Gameplays/ArcOnRuler/ArcOnRuler.js"),
  ChatbotMultipleChoice: () => import("./Components/Gameplays/ChatbotMultipleChoice/ChatbotMultipleChoice.js"),
  ChatbotOpenQuestion: () => import("./Components/Gameplays/ChatbotOpenQuestion/ChatbotOpenQuestion.js"),
  ChatbotReorder: () => import("./Components/Gameplays/ChatbotReorder/ChatbotReorder.js"),
  ChatbotSelectAndCorrect: () => import("./Components/Gameplays/ChatbotSelectAndCorrect/ChatbotSelectAndCorrect.js"),
  ChatbotSelectClick: () => import("./Components/Gameplays/ChatbotSelectClick/ChatbotSelectClick.js"),
  ChatbotSelectDropdown: () => import("./Components/Gameplays/ChatbotSelectDropdown/ChatbotSelectDropdown.js"),
  ChatbotSingleChoice: () => import("./Components/Gameplays/ChatbotSingleChoice/ChatbotSingleChoice.js"),
  CircleComparator: () => import("./Components/Gameplays/CircleComparator/CircleComparator.js"),
  Coefficient: () => import("./Components/Gameplays/Coefficient/Coefficient.js"),
  ColoringShapes: () => import("./Components/Gameplays/ColoringShapes/ColoringShapes.js"),
  Connect: () => import("./Components/Gameplays/Connect/Connect.js"),
  CrossProduct: () => import("./Components/Gameplays/CrossProduct/CrossProduct.js"),
  Domino: () => import("./Components/Gameplays/Domino/Domino.js"),
  DropCompare: () => import("./Components/Gameplays/DropCompare/DropCompare.js"),
  DropQuantity: () => import("./Components/Gameplays/DropQuantity/DropQuantity.js"),
  GraduatedRuler: () => import("./Components/Gameplays/GraduatedRuler/GraduatedRuler.js"),
  GroupingElements: () => import("./Components/Gameplays/GroupingElements/GroupingElements.js"),
  Highlight: () => import("./Components/Gameplays/Highlight/Highlight.js"),
  HorizontalGraduation: () => import("./Components/Gameplays/HorizontalGraduation/HorizontalGraduation.js"),
  InputField: () => import("./Components/Gameplays/InputField/InputField.js"),
  InputLine: () => import("./Components/Gameplays/InputLine/InputLine.js"),
  InputLineGlobal: () => import("./Components/Gameplays/InputLineGlobal/InputLineGlobal.js"),
  InputRectangle: () => import("./Components/Gameplays/InputRectangle/InputRectangle.js"),
  InputRectangleDimension: () => import("./Components/Gameplays/InputRectangleDimension/InputRectangleDimension.js"),
  InputTable: () => import("./Components/Gameplays/InputTable/InputTable.js"),
  IntervalColoring: () => import("./Components/Gameplays/IntervalColoring/IntervalColoring.js"),
  IntervalRuler: () => import("./Components/Gameplays/IntervalRuler/IntervalRuler.js"),
  Media: () => import("./Components/Gameplays/Media/Media.js"),
  Memory: () => import("./Components/Gameplays/Memory/Memory.js"),
  MultiGameplay: () => import("./Components/Gameplays/MultiGameplay/MultiGameplay.js"),
  MultipleChoice: () => import("./Components/Gameplays/MultipleChoice/MultipleChoice.js"),
  MultipleRatio: () => import("./Components/Gameplays/MultipleRatio/MultipleRatio.js"),
  MultiplicationDivision: () => import("./Components/Gameplays/MultiplicationDivision/MultiplicationDivision.js"),
  NumberBox: () => import("./Components/Gameplays/NumberBox/NumberBox.js"),
  PlacingPoint: () => import("./Components/Gameplays/PlacingPoint/PlacingPoint.js"),
  PrimeNumberTree: () => import("./Components/Gameplays/PrimeNumberTree/PrimeNumberTree.js"),
  RandomDraw: () => import("./Components/Gameplays/RandomDraw/RandomDraw.js"),
  RandomLayout: () => import("./Components/Gameplays/RandomLayout/RandomLayout.js"),
  RectangleNumber: () => import("./Components/Gameplays/RectangleNumber/RectangleNumber.js"),
  SegmentComparator: () => import("./Components/Gameplays/SegmentComparator/SegmentComparator.js"),
  SpatialRelation: () => import("./Components/Gameplays/SpatialRelation/SpatialRelation.js"),
  VittascienceCodeImplementation: () => import("./Components/Gameplays/VittascienceCodeImplementation/VittascienceCodeImplementation.js"),
  VittascienceMultipleChoice: () => import("./Components/Gameplays/VittascienceMultipleChoice/VittascienceMultipleChoice.js"),
  Writing: () => import("./Components/Gameplays/Writing/Writing.js")
}, a = Object.keys(i), n = async (r) => {
  const t = e.pascal(r), o = i[t];
  if (!o)
    throw new Error(`Gameplay ${t} not available.`);
  return (await o()).default;
};
export {
  a as availableGameplays,
  i as gameplayRegistry,
  n as getGameplay
};
//# sourceMappingURL=registry.js.map
